module.exports = __webpack_public_path__ + "media/images/redesign-images/get-inspired/gi-design-1-8e5d5c45a92362c3319703d4f31a042a.jpg";